<template>
    <v-main>
        <div v-if="initialpageloading && !genus.length">
            <v-container>
                <v-row  >
                    <v-col cols="12" class="text-center">
                        <v-progress-circular
                                :size="100"
                                :width="7"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div v-else>
        <v-container v-if="genus">
            <head>
                <title>{{genus.name}} - Foraje</title>
                <meta name="description" :content="genus.short_description">
            </head>
            <v-row  >
                <v-col class="pa-4" cols="12" sm="6" >
                    <v-card flat class="transparent" >
                        <v-carousel :cycle="false" v-if="genusimages && genusimages.length">
                            <v-carousel-item v-for="(item,i) in genusimages" :key="i" :src="item.image.full_size" :lazy-src="item.image.thumbnail">

                            </v-carousel-item>
                        </v-carousel>
                        <v-img v-else src="https://nyc3.digitaloceanspaces.com/foraje-static-1/media/static/images/misc/unknownchile.svg"
                               class="white--text"></v-img>
                    </v-card>
                </v-col>

                <v-col class="pa-2" cols="12" sm="6" >
                    <v-card>
                        <v-col class="ma-4" > <!--I'd prefer to use v-card-title, but can't get it to look the way I'd like.-->
                            <h2>{{genus.name}} <v-btn v-if="genus.wikipedia_url !== null" v-bind:href="genus.wikipedia_url" text icon outlined large color="light-green darken-4">
                                <v-icon>mdi-wikipedia</v-icon>
                            </v-btn>
                            </h2>
                            <router-link  v-if="genus.taxonomic_family" v-bind:to="'/guide/taxonomic_family/' + genus.taxonomic_family.slug"><h4 v-if="genus.taxonomic_family"><em>{{genus.taxonomic_family.name}}</em></h4></router-link>
                        </v-col>
                        <v-divider inset></v-divider>
                        <v-card-title primary-title>
                            <h3>Quick Look</h3>
                        </v-card-title>
                        <v-card-text>
                            <ul>
                                <li>Common Name: {{genus.common_name}}</li>
                                <li v-if="genus.short_description">{{genus.short_description}}</li>
                                <li v-else-if="genus.description">{{genus.description.substring(0,255)}}...</li>
                                <li v-else>Sorry, we don't have a basic description for this genus yet.</li>
                            </ul>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
            <v-divider></v-divider>
            <v-divider></v-divider>
        <v-tabs light fixed-tabs icons-and-text centered slider-color="yellow">
            <v-tab key="general_info">
                General Info
                <v-icon>mdi-information-outline</v-icon>
            </v-tab>
            <v-tab key="species" @click.native="FirstClickFetchSpecies">
                Known Species
                <v-icon>mdi-file-tree-outline</v-icon>
            </v-tab>


            <v-tab-item key="general_info">
                <v-container>
                    <v-row  >
                        <v-col cols="12">
                            <v-card>
                                <v-card-title primary-title>
                                    <h2>Description</h2>
                                </v-card-title>
                                <v-card-text v-if="genus.description && genus.description.length">
                                    {{genus.description}}
                                </v-card-text>
                              <v-card-text v-else>
                                <p>No Description Available</p>
                              </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-tab-item>


            <v-tab-item key="species">
                <v-container>
                    <v-row   v-if="arespeciesloading && !species.length">
                        <v-col cols="12" class="text-center">
                            <v-progress-circular
                                    :size="100"
                                    :width="7"
                                    color="primary"
                                    indeterminate
                            ></v-progress-circular>
                        </v-col>
                    </v-row>

                        <div id="KnownSpeciesTop" v-if="species && species.length"><h2>Known Species</h2></div>
                        <v-col v-else-if="!arespeciesloading" cols="12" class="text-center">
                            <v-btn @click.native="FetchSpecies"
                                   class="primary"
                            >
                                Fetch known species of this genus
                                <span slot="loader" class="custom-loader">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </span>
                            </v-btn>
                        </v-col>
                        <v-row   v-if="species && species.length">
                          <v-col cols="12" sm="6" md="4" v-for="specie of species" :key="specie.id">


                                <v-card raised hover :to="'/guide/species/' + specie.slug">
                                    <v-row>
                                        <v-col class="pa-sm-3 ml-sm-3 pa-10" cols="12" sm="5" v-if="specie && specie.species_image.image" >
                                            <!--Displays image of the species, a filled box for mobile (might wanna switch to a small box and hide the text
                                            or something else instead.) and a rounded image for everyone else. Also a placeholdder if there is no image-->
                                            <v-img
                                                    :src="specie.species_image.image.thumbnail"
                                                    class="FetchedThumbail hidden-xs-only"
                                                    aspect-ratio="1"
                                            ></v-img>
                                            <v-img
                                                    :src="specie.species_image.image.full_size"
                                                    class="FetchedThumbail hidden-sm-and-up"
                                                    aspect-ratio="1"
                                            ></v-img>
                                        </v-col>
                                      <v-col cols="12" sm="5" v-else>
                                        <v-img
                                          src="https://nyc3.digitaloceanspaces.com/foraje-static-1/media/static/images/misc/unknownchile.svg"
                                          class="white--text"
                                        ></v-img>
                                      </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-card-title primary-title>
                                                    <div class="headline" style="word-break: normal"><router-link v-bind:to="'/guide/species/' + specie.slug">{{specie.name}}</router-link></div>
                                            </v-card-title>
                                          <v-card-text>
                                            <p>{{specie.short_description}}</p>
                                          </v-card-text>
                                        </v-col>
                                    </v-row>
                                </v-card>

                            </v-col>

                            <v-col cols="12" class="text-center">
                                <v-btn
                                        v-if="this.speciespageCount > 1"
                                        @click="SpeciesLoadPreviousBatch"
                                        :loading="arespeciesloading"
                                        class="secondary"
                                >
                                    Previous Species
                                    <span slot="loader" class="custom-loader">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </span>
                                </v-btn>
                                <v-btn
                                        v-if="this.speciesfullresponse.next !== null"
                                        @click="SpeciesLoadNextBatch"
                                        :loading="arespeciesloading"
                                        class="primary"
                                >

                                    More Species!
                                    <span slot="loader" class="custom-loader">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </span>
                                </v-btn>
                            </v-col>
                        </v-row>
                </v-container>
            </v-tab-item>


        </v-tabs>
        </div>
    </v-main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Genus',
  data: () => ({

    genus: [],
    genusimages: [],


    species: [],
    speciesfullresponse: [],
    speciespageCount: 1,


    initialpageloading: false,
    arespeciesloading: false,
  }),
  methods: {
    FetchGenusData() {
      this.initialpageloading = true;
      const genusSlug = this.$route.params.slug;
      axios.get(`genera/${genusSlug}/`)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.genus = response.data;
          const genusId = this.genus.id;
          this.FetchGenusImages(genusId);
        })
        .then(() => {
          this.initialpageloading = false;
        });
    },
    FetchGenusImages(genusId) {
      axios.get(`/image/by/genus/${genusId}/`)
        .then((response) => {
          this.genusimages = response.data.results;
        });
    },
    FetchSpecies() {
      const genusId = this.genus.id;
      this.arespeciesloading = true;
      axios.get(`filtered/species/by/genus/${genusId}/?page=${this.speciespageCount}`)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.species = response.data.results;
          this.speciesfullresponse = response.data;
        })
        .then(() => {
          this.arespeciesloading = false;
        })
        .catch((e) => {
          this.errors.push(e);
          this.arespeciesloading = false;
        });
    },
    FirstClickFetchSpecies() {
      if (!this.species.length) {
        this.FetchSpecies();
      }
    },
    SpeciesLoadNextBatch() {
      if (this.speciesfullresponse.next != null) {
        this.speciespageCount += 1;
        this.FetchVarieties();
      }
    },

    SpeciesLoadPreviousBatch() {
      this.speciespageCount -= 1;
      this.FetchVarieties();
    },
  },
  computed: {
    userIsAuthenticated() {
      return this.$store.getters.token;
    },
  },


  created() {
    // Not super elegant, but hey, it works.
    this.FetchGenusData();
  },


};
</script>

<style scoped>
    .FetchedThumbail{
        border-radius: 50%;
    }
    >>>.v-carousel__next > .v-btn{
        background: rgba(0,0,0,.5)
    }
    >>>.v-carousel__prev > .v-btn{
        background: rgba(0,0,0,.5)
    }
</style>
